import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	eventName: {
		textAlign: "start",
		whiteSpace: "nowrap",
		overflow: "hidden",
		maxWidth: 227,
		textOverflow: "ellipsis",
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[400]),
		borderRadius: "8px",
		color: colors.gray[0],
		fontWeight: "bold"
	},
	conversionEventName: {
		width: "100%"
	}
})

export default useStyles
